module.exports = require("core-js-pure/features/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js
// module id = 3493
// module chunks = 25